import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { DocumentTypeOutputDTO } from './documentTypeDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class DocumentTypeServices {
  async getByAll(): Promise<DocumentTypeOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/document-type/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const documentTypeServices = new DocumentTypeServices()
